<template>
  <!-- 支付成功页面 -->
  <div class="paysuce">
    <div class="paysuce_cont">
      <p></p>
      <p>您已支付成功！</p>
      <p>立即学习吧</p>
      <div>
        <div>
          <router-link :to="{name:'home'}">返回首页</router-link>
        </div>
        <div v-if="this.$route.query.payType == 1">
          <router-link :to="{name:'userMyCourse'}">我的课程</router-link>
        </div>
        <div v-if="this.$route.query.payType == 2">
          <router-link :to="{name:'userVip'}">VIP中心</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  }
}
</script>
<style lang="less" scoped>
.paysuce_cont {
    width: 1200px;
    height: 608px;
    margin: 0 auto;
    margin-top: 147px;
    background: #ffffff;
    border: 1px solid #bfbfbf;
    box-shadow: 0px 1px 20px 0px rgba(119, 119, 119, 0.2);
    p:nth-child(1) {
        width: 290px;
        height: 274px;
        background: url('../../assets/img/paysuces.png') no-repeat;
        background-size: cover;
        margin: 0 auto;
        margin-top: 40px;
    }
    p:nth-child(2) {
        color: #000000;
        font-size: 24px;
        text-align: center;
        letter-spacing: 1px;
    }
    p:nth-child(3) {
        color: #606060;
        font-size: 16px;
        text-align: center;
        letter-spacing: 1px;
        margin-top: 13px;
    }
    div:nth-child(4) {
        width: 31%;
        margin: 0 auto;
        margin-top: 60px;
        cursor: pointer;
        div {
            display: inline-block;
            width: 140px;
            height: 40px;
            background: #167eff;
            border-radius: 20px;
            background: #167eff;
            color: #ffffff;
            font-size: 18px;
            text-align: center;
            line-height: 40px;
            a {
                color: #fff;
            }
        }
        div:nth-child(2) {
            margin-left: 80px;
        }
    }
}
</style>